import UserInfo from '../common/types/UserInfo';
import LanguageSlice from '../common/slices/LanguageSlice';
import { LanguageService } from '../services';
import { ThunkDispatch } from '@reduxjs/toolkit';

export default function setLocaleFromUserInfo(
    data: UserInfo,
    currentLocale: string,
    dispatch: ThunkDispatch<any, any, any>,
) {
    if (data?.locale && data.locale !== currentLocale) {
        dispatch(LanguageSlice.actions.changeLocale(data.locale));
    } else if (
        data?.allowedLanguages?.length > 0 &&
        !data.allowedLanguages.includes(currentLocale)
    ) {
        const defaultLocale = LanguageService.getDefaultLocale(
            data.allowedLanguages,
        );

        if (currentLocale !== defaultLocale) {
            dispatch(LanguageSlice.actions.changeLocale(defaultLocale));
        }
    }
}
